/* import __COLOCATED_TEMPLATE__ from './social-media-image.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();